export enum VehicleType {
    Car,
    Suv,
    Van,
    Pickup,
    Freight,
    Bus,
    Convertible,
    Hatchback,
    Unsure
}

export function showVehicleType(style: VehicleType): string {
    switch( style ) {
        case VehicleType.Car:         return "Car";
        case VehicleType.Suv:         return "SUV";
        case VehicleType.Van:         return "Van";
        case VehicleType.Pickup:      return "Pickup";
        case VehicleType.Freight:     return "Freight";
        case VehicleType.Bus:         return "Bus";
        case VehicleType.Convertible: return "Convertible";
        case VehicleType.Hatchback:   return "Hatchback";
        case VehicleType.Unsure:      return "Unsure";
    }    
}

export function parseVehicleType( str: string ): VehicleType | undefined {
    switch (str) {
        case "Car":         return VehicleType.Car;
        case "SUV":         return VehicleType.Suv;
        case "Van":         return VehicleType.Van;
        case "Pickup":      return VehicleType.Pickup;
        case "Freight":     return VehicleType.Freight;
        case "Bus":         return VehicleType.Bus;
        case "Convertible": return VehicleType.Convertible;
        case "Hatchback":   return VehicleType.Hatchback;
        case "Unsure":      return VehicleType.Unsure;
        default:            return undefined;
    }
}

export const vehicleTypes: VehicleType[] = [
    VehicleType.Car,
    VehicleType.Suv,
    VehicleType.Van,
    VehicleType.Pickup,
    VehicleType.Freight,
    VehicleType.Bus,
    VehicleType.Convertible,
    VehicleType.Hatchback,
    VehicleType.Unsure
];